<div class="diagnostic-results">
  <ng-container *ngFor="let result of resultsData">
    <prf-diagnostic-results-accordion [result]="result"></prf-diagnostic-results-accordion>
  </ng-container>
</div>
